<template>
  <div class="row">
    <div class="medium-6 columns">
      <section>
        <h1 v-html="confirmationPageData.pageHeadline" />

        <p v-html="confirmationPageData.confirmationText" />

        <base-button-link
          class="large-6"
          :large="true"
          :href="confirmationPageData.selfServiceLink.url"
          :target="confirmationPageData.selfServiceLink.target"
          v-html="confirmationPageData.selfServiceLink.text"
        />
      </section>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BaseButtonLink from '@/components/UI/BaseButtonLink.vue';

export default {
  name: 'Confirmation',
  components: { BaseButtonLink },
  computed: mapState({
    confirmationPageData: (state) => state.bikeTheftClaimFlow.data.confirmationPage
  })
};
</script>
